// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R2css","content":"styles_content__2-tDm","row":"styles_row__1VhyY","footer":"styles_footer__9yzgZ","phraseLength":"styles_phraseLength__3SdxO"};